import { useState, useEffect, useRef } from "react";

interface PwaUpdateModalProps {
  open: boolean;
}

export function PwaUpdateModal({ open }: PwaUpdateModalProps) {
  const [count, setCount] = useState(3);
  const triggered = useRef(false);

  useEffect(() => {
    if (!open) {
      setCount(3);
      triggered.current = false;
      return;
    }

    if (count <= 0) {
      if (!triggered.current) {
        triggered.current = true;
        window.dispatchEvent(new CustomEvent("pwa-do-update"));
      }
      return;
    }

    const t = setTimeout(() => setCount((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [open, count]);

  if (!open) return null;

  const radius = 40;
  const circumference = 2 * Math.PI * radius;
  const progress = count / 3;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-5 rounded-2xl bg-background p-8 shadow-2xl border border-border/40 w-[280px]">
        <div className="relative flex items-center justify-center">
          <svg width="100" height="100" className="-rotate-90">
            <circle
              cx="50"
              cy="50"
              r={radius}
              fill="none"
              stroke="hsl(var(--muted))"
              strokeWidth="6"
            />
            <circle
              cx="50"
              cy="50"
              r={radius}
              fill="none"
              stroke="hsl(var(--primary))"
              strokeWidth="6"
              strokeLinecap="round"
              strokeDasharray={circumference}
              strokeDashoffset={circumference * (1 - progress)}
              className="transition-[stroke-dashoffset] duration-1000 ease-linear"
            />
          </svg>
          <span className="absolute text-3xl font-bold text-foreground tabular-nums">
            {count > 0 ? count : "✓"}
          </span>
        </div>
        <p className="text-sm font-medium text-muted-foreground text-center">
          A atualizar a app...
        </p>
      </div>
    </div>
  );
}
